/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Status_Preparing_VoInputs */



/**
* | output |
* | --- |
* | "Preparing VO Track..." |
*
* @param {Audio_Description_Export_Status_Preparing_VoInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_status_preparing_vo = /** @type {((inputs?: Audio_Description_Export_Status_Preparing_VoInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Status_Preparing_VoInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Préparation de la piste VO...")
	if (locale === "de") return /** @type {LocalizedString} */ ("VO-Track wird vorbereitet...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Preparazione della traccia VO...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Подготовка аудиодорожки...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Preparando pista VO...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("准备配音轨道……")
	if (locale === "ja") return /** @type {LocalizedString} */ ("VOトラックを準備しています...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वॉयस ओवर ट्रैक तैयार किया जा रहा है...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Preparando a locução...")
	return /** @type {LocalizedString} */ ("Preparing VO Track...")
});